import { getTitleByLanguage, Transactions } from "./getTitleByLanguage";

interface Props {
  title: string;
  translations: Transactions[];
  locale: string;
  key: string;
}

export const formatTitleByLocale = ({
  title,
  translations,
  locale,
  key,
}: Props) => {
  /**
   * Safely format the title according to the provided locale.
   * Guard clauses protect against cases where the `translations` array is
   * null/undefined or not an array – this can happen when the backend does
   * not return translations for a particular property. In such cases we
   * gracefully fall back to the original title to avoid runtime exceptions
   * that would otherwise crash the page on production (e.g. 500 errors).
   */

  if (!Array.isArray(translations) || translations.length === 0) {
    return title;
  }

  return getTitleByLanguage(translations, title, locale, key);
};
